<template>
  <div>
    <h2>{{ title }}</h2>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <div v-on:keypress.enter.prevent="getNewsTable(1)">
          <input-search
            :model="search" @update="searchInput"/>
        </div>
        <circle-button
          v-if="permissionNews && permissionNews.permission_id === permission.readWrite"
          @click.native="createNewsData"/>
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-center" v-for="header in headers" :key="header.id">
              {{ header.text }}
              <template v-if="header.icon">
                <a @click="sortDataTable(header.name)">
                  <v-icon class="fas fa-caret-down"
                          v-if="sort_date == 'desc'"
                          style="font-size: 12px"></v-icon>
                  <v-icon class="fas fa-caret-up"
                          v-if="sort_date == 'asc'"
                          style="font-size: 12px"></v-icon>
                </a>
              </template>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(data,index) in dataTable">
            <td>{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
            <td>{{returnBranchName(data.branch_id)}}</td>
            <td>{{data.title_en}}</td>
            <td>{{data.publish_date | moment('DD-MM-YYYY')}}</td>
            <td>{{data.content_updated_at | moment('DD-MM-YYYY')}}</td>
            <td>
              <a @click="showNewsData(data.news_id)">
                <icon-pencil />
              </a>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
    import CircleButton from "../../../components/Button/CircleButton";
    import InputSearch from "../../../components/Input/InputSearch";
    import IconPencil from "../../../components/Icon/icon-pencil";
    import Paginate from "../../../components/Layout/Paginate";
    import {permissionNews, role} from "../../../util/Permission";
    import Swal from 'sweetalert';
    import Loading from 'vue-loading-overlay';

    export default {
      components: {Paginate, IconPencil, InputSearch, CircleButton, Loading},
      name: "NewsTable",
      computed:{
        permissionNews,
      },
      data(){
        return{
          title: "News",
          isLoading: false,
          headers: [
            { id: 1, text: "No." ,icon : null, name: ''},
            { id: 2, text: "Branch" ,icon : null, name: ''},
            { id: 3, text: "Title" ,icon : null, name: ''},
            { id: 4, text: "Publish date" ,icon : true, name: "publish_date"},
            { id: 5, text: "Update date" ,icon : true,name: "updated_at"},
            { id: 6, text: "Edit" ,icon : null, name: ''}
          ],
          dataTable: [],
          allbranches: [],
          dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
          },
          permission : null,
          search : '',
          sort_date : 'desc',
          sort_column : null,
        }
      },
      async created() {
        this.permission = role;
        this.getNewsTable(1);
        this.allbranches = await this.$store.dispatch('Branch/getBranchAll')
      },
      methods:{
        getNewsTable(page){
          this.isLoading = true;
          this.$store.dispatch("News/getNews",{
            page ,
            search : this.search,
            sort_date : this.sort_date,
            sort_column : this.sort_column
          }).then(res=>{
            if(res.response_code == 200){
              this.dataTable = res.result.data;
              this.dataPaginate = {
                current_page: res.result.current_page,
                from: res.result.from,
                last_page: res.result.last_page,
                per_page: res.result.per_page,
                total: res.result.total,
                to: res.result.to
              }
            }else{
              Swal(res.response_msg);
            }
            this.isLoading = false;
          })
        },
        async changePage(val){
          this.isLoading = true;
          this.dataPaginate.current_page = val;
          await this.getNewsTable(this.dataPaginate.current_page);
          this.isLoading = false;
        },
        goToNewsEdit(id){
          if (!id) this.$router.push({ name: 'news-edit' });
          this.$router.push({ name: 'news-edit', params: { id: id } });
        },
        showNewsData(id){
          this.isLoading = true;
          this.goToNewsEdit(id);
          // this.$store.dispatch("News/showNews",id).then(res=>{
          //   if(res.response_code == 200){
          //     this.$store.dispatch("News/setFormNews",res.result).then(()=>{
          //     });
          //   }else{
          //     Swal(res.response_msg);
          //   }
          //   this.isLoading = false;
          // })
        },
        createNewsData(){
          this.$store.dispatch("News/clearFormData").then(()=>{
            this.goToNewsEdit();
          })
        },
        searchInput(val){
          this.search = val;
        },
        sortDataTable(val){
          this.sort_column = val ? val : '';
          this.sort_date = this.sort_date == 'desc' ? 'asc' : 'desc';
          this.getNewsTable(1);
        },
        returnBranchName (branch_id) {
          if (!branch_id) return ''
          let ids = branch_id.split(',')
          let result = []
          for (const id of ids) {
            for (const b of this.allbranches) {
              if (id == b.branch_id) {
                result.push(b.branch_name_th)
              }
            }
          }
          return result.join(', ')
        }
      }
    }
</script>

<style lang="scss" scoped>
  .branch-data {
    background-color: transparent;
    margin: 20px;
  }
</style>
